import React from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import lediumApi from '@client/utils/lediumApi';

const DmxChannelInput = () => {
    const {
        pageState: { formData },
        pageActions
    } = usePageStore();
    const dmx_min = 1;
    const dmx_max = 512;

    async function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        pageActions.formData.updateFormItem({ channel: event.target.value });
    }

    React.useEffect(() => {
        ValidatorForm.addValidationRule('checkChannelConflict', async () => {
            const api = `lightChannels/isDmxUsed/${formData.resolution}/${formData.channel}/${formData.id ? formData.id : null}`;
            const channelAvailable = await lediumApi.get<{ isUsed: boolean }>(api);
            if (!channelAvailable) {
                return true;
            }
            pageActions.formData.updateFormItem({ channelConflict: channelAvailable.isUsed });
            return !channelAvailable.isUsed;
        });
        return () => ValidatorForm.removeValidationRule('checkChannelConflict');
    }, [formData.channel]);

    return (
        <TextValidator
            label={i18n('dmx_channel_X_to_Y', dmx_min, dmx_max)}
            type="number"
            onChange={handleChange}
            value={formData.channel}
            min={dmx_min}
            max={dmx_max}
            variant="outlined"
            validators={['required', 'isNumber', 'minNumber:1', 'maxNumber:512', 'checkChannelConflict']}
            errorMessages={[
                i18n('this_field_is_required'),
                i18n('invalid_number'),
                i18n('the_value_should_be_minimum_X', dmx_min),
                i18n('the_value_should_be_maximum_X', dmx_max),
                i18n('the_dmx_channel_is_used')
            ]}
        />
    );
};

export default DmxChannelInput;
